// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_List from "../../../../../../node_modules/rescript/lib/es6/belt_List.js";

function machine(state, action) {
  if (typeof state === "number") {
    switch (action.TAG | 0) {
      case /* SetCustomerOrder */0 :
          return {
                  TAG: /* CustomerOrder */0,
                  _0: action._0
                };
      case /* SetCustomerOrderFailed */1 :
          return {
                  TAG: /* Error */1,
                  _0: action._0
                };
      case /* UpdateCustomerOrder */2 :
      case /* UpdateCustomerOrderFailed */3 :
          return /* Init */0;
      
    }
  } else {
    if (state.TAG !== /* CustomerOrder */0) {
      return state;
    }
    switch (action.TAG | 0) {
      case /* SetCustomerOrder */0 :
      case /* SetCustomerOrderFailed */1 :
          return /* Init */0;
      case /* UpdateCustomerOrder */2 :
          var data = action._0;
          var finalData_last_date_timestamp = data.last_date_timestamp;
          var finalData_orders = Belt_List.concat(state._0.orders, data.orders);
          var finalData = {
            last_date_timestamp: finalData_last_date_timestamp,
            orders: finalData_orders
          };
          return {
                  TAG: /* CustomerOrder */0,
                  _0: finalData
                };
      case /* UpdateCustomerOrderFailed */3 :
          return {
                  TAG: /* Error */1,
                  _0: action._0
                };
      
    }
  }
}

var StateMachine = {
  machine: machine
};

export {
  StateMachine ,
  
}
/* No side effect */
